export const Partners = [
  {
    name: "Mayor of London",
    logoURL: "logos/logo-mayor-of-london.png",
    externalURL: "https://www.london.gov.uk",
  },
  {
    name: "Barking and Dagenham Council",
    logoURL: "logos/logo-barking-dagenham.svg",
    externalURL: "https://www.lbbd.gov.uk/",
  },
  {
    name: "SSE",
    logoURL: "logos/logo-sse.png",
    externalURL: "https://www.the-sse.org/",
  },
  {
    name: "Highfields",
    logoURL: "logos/logo-highfields.png",
    externalURL: "https://www.highfieldqualifications.com/",
  },
  {
    name: "Disability Confident",
    logoURL: "logos/logo-disability-confident.png",
    externalURL: "https://disabilityconfident.campaign.gov.uk/",
  },
  {
    name: "Shpresa Programme",
    logoURL: "logos/logo-shpresa.png",
    externalURL: "https://shpresaprogramme.org/",
  },
];